'use client';
import styled from '@benzinga/themetron';
import React from 'react';
import { Impression } from '@benzinga/analytics';

export type CampaignifyVariant =
  | 'insider-report-bordered'
  | 'the-best-report'
  | 'secure-your-financial-future'
  | 'secure-your-financial-future-bordered'
  | 'secure-your-financial-future-insider-report'
  | 'claim-your-free-benzinga-pro-access'
  | 'discover-the-power-of-triple-threat-stocks'
  | '27-profit-every-20-days';

export interface CampaignifyUnitProps {
  utmSource: string;
  variant?: CampaignifyVariant;
  url?: string;
}

export const CampaignifyUnit: React.FC<CampaignifyUnitProps> = ({ url, utmSource = '', variant }) => {
  let element = <div />;
  if (variant === 'insider-report-bordered') {
    const href =
      url ||
      (utmSource
        ? `https://events.benzinga.com/your-insider-report-v2?utm_source=${utmSource}`
        : `https://events.benzinga.com/your-insider-report-v2`);
    element = (
      <div className="text-inherit no-underline">
        <a
          className="banner3 box-border bg-white rounded flex items-center justify-between w-full max-w-[720px] relative overflow-hidden flex-wrap mx-auto mb-2.5 p-4 border border-[#ceddf2]"
          href={href}
        >
          <div className="flex flex-col items-start justify-start gap-2 relative flex-1">
            <div className="icon3 flex items-center justify-start relative shrink-0 flex-wrap self-stretch gap-4">
              <img
                alt="Tech Notification Icon"
                className="relative overflow-visible shrink-0"
                height={24}
                src="https://cdnwp-s3.benzinga.com/wp-content/uploads/2023/07/21145438/Icons-Tech-Notification.png"
                width={24}
              />
              <div className="flex justify-start relative flex-1 flex-wrap gap-2.5">
                <img
                  alt="Benzinga Logo"
                  className="relative overflow-visible shrink-0"
                  src="https://cdnwp-s3.benzinga.com/wp-content/uploads/2023/07/24162327/insider.png"
                />
              </div>
            </div>
            <div className="flex items-center justify-start flex-wrap gap-4 relative shrink-0 self-stretch">
              <div className="text-left relative flex-1">
                <span>
                  <span className="text-[#5b7292]">Gain an Edge on Market Trends</span>
                </span>
              </div>
            </div>
          </div>
        </a>
      </div>
    );
  } else if (variant === 'the-best-report') {
    const href =
      url ||
      (utmSource
        ? `https://events.benzinga.com/your-insider-report-v2?utm_source=${utmSource}`
        : `https://events.benzinga.com/your-insider-report-v2`);
    element = (
      <>
        <hr />
        <strong className="block text-center font-semibold pt-4">The Best Report Benzinga Has Ever Produced</strong>
        <p className="text-left p-[15px] mx-auto" style={{ maxWidth: '630px' }}>
          Massive returns are possible within this market! For a limited time, get access to the Benzinga Insider
          Report, usually $47/month, for just $0.99! Discover extremely undervalued stock picks before they skyrocket!
          Time is running out! Act fast and secure your future wealth at this unbelievable discount!
          <a href={href}>
            <strong>Claim Your $0.99 Offer NOW!</strong>
          </a>
        </p>
        <p className="text-right px-0.5">
          <span className="text-[#808080]">
            <em>Advertorial</em>
          </span>
        </p>
        <hr />
      </>
    );
  } else if (variant === 'secure-your-financial-future-bordered') {
    const href =
      url ||
      (utmSource
        ? `https://events.benzinga.com/your-insider-report-v2?utm_source=${utmSource}`
        : `https://events.benzinga.com/your-insider-report-v2`);
    element = (
      <div className="text-inherit no-underline font-manrope">
        <a
          className="banner3 box-border bg-white rounded flex items-center justify-between w-full max-w-[720px] relative overflow-hidden flex-wrap mx-auto mb-2.5 p-4 border border-[#ceddf2]"
          href={href}
        >
          <div className="flex flex-col items-start justify-start gap-2 relative flex-1">
            <div className="icon3 flex items-center justify-start relative shrink-0 flex-wrap self-stretch gap-4">
              <div className="flex justify-start relative flex-1 flex-wrap gap-2.5">
                <img
                  alt="Benzinga Logo"
                  className="relative overflow-visible shrink-0 h-[14px]"
                  src="https://cdnwp-s3.benzinga.com/wp-content/uploads/2023/06/30092023/1-5.png"
                />
              </div>
            </div>
            <div className="flex items-center justify-start flex-wrap gap-4 relative shrink-0 self-stretch">
              <div className="text-left relative flex-1">
                <strong className="block text-2xl font-semibold">Secure Your Financial Future</strong>
                <span>
                  <span className="text-[#5b7292]">
                    Hidden gems are waiting to be uncovered in this market. Discover incredibly undervalued stocks
                    before they soar! Benzinga Insider Report, typically $47/month.
                  </span>{' '}
                  <span className="text-blue-500">Now ONLY $0.99! Limited Time offer! CLAIM NOW!</span>
                </span>
              </div>
            </div>
          </div>
        </a>
      </div>
    );
  } else if (variant === 'claim-your-free-benzinga-pro-access') {
    const href =
      url ||
      (utmSource
        ? `https://benzinga.grsm.io/campaignify-trial?utm_source=${utmSource}`
        : `https://benzinga.grsm.io/campaignify-trial`);
    element = (
      <div className="my-2">
        <hr />
        <h4 className="text-center pt-4">Claim Your FREE Benzinga Pro Access and Stay Ahead of the Markets</h4>
        <p className="text-left p-[15px] mx-auto" style={{ maxWidth: '660px' }}>
          Tired of missing out on huge stock moves almost every day? With Benzinga Pro, you never miss the news behind
          huge price spikes. Our real-time alerts consistently highlight news items that propel stock prices up anywhere
          from 20% to 250% everyday, giving you the edge to make informed trades and maximize your profits.{' '}
          <strong>
            <a className="underline" href={href} rel="noreferrer" target="_blank">
              Join Benzinga Pro now FREE!
            </a>
          </strong>
        </p>
        <p className="text-right">
          <span className="text-[#808080]">
            <em>Advertorial</em>
          </span>
        </p>
        <hr />
      </div>
    );
  } else if (variant === 'secure-your-financial-future-insider-report') {
    const href =
      url ||
      (utmSource
        ? `https://www.benzinga.com/go/insider-report?utm_source=${utmSource}`
        : `https://www.benzinga.com/go/insider-report`);
    element = (
      <div className="my-2">
        <hr />
        <h4 className="text-center pt-4">Secure Your Financial Future</h4>
        <p className="text-left p-[15px] mx-auto max-w-[630px]">
          Hidden gems are waiting to be found in this market! Don't miss the Benzinga Insider Report, typically
          $47/month, now ONLY $0.99! Uncover incredibly undervalued stocks before they soar! Limited time offer! Secure
          your financial success with this unbeatable discount!{' '}
          <strong>
            <a className="underline" href={href} rel="noreferrer" target="_blank">
              Grab your 0.99 offer TODAY!
            </a>
          </strong>
        </p>
        <p className="text-right">
          <span className="text-[#808080]">
            <em>Advertorial</em>
          </span>
        </p>
        <hr />
      </div>
    );
  } else if (variant === 'discover-the-power-of-triple-threat-stocks') {
    const href =
      url ||
      (utmSource
        ? `https://www.benzinga.com/go/insider-report?utm_source=${utmSource}`
        : `https://www.benzinga.com/go/insider-report`);
    element = (
      <div className="my-2">
        <hr />
        <h4 className="text-center pt-4">Discover the power of "triple-threat stocks" today!</h4>
        <p className="text-left p-[15px] mx-auto max-w-[650px]">
          Legendary investor, Tim Melvin, unearths overlooked "triple-threat stocks" in his Yield Report. Want a short
          at handsome opportunities in both a bear and bull market? See if you qualify for The Yield Report.{' '}
          <strong>
            <a className="font-extrabold" href={href} rel="noreferrer" target="_blank">
              Read the qualifications right here right now.
            </a>
          </strong>
        </p>
        <hr />
      </div>
    );
  } else if (variant === '27-profit-every-20-days') {
    const href =
      url ||
      (utmSource
        ? `https://www.benzinga.com/premium/ideas/money-line/?utm_source=${utmSource}`
        : `https://www.benzinga.com/premium/ideas/money-line`);
    element = (
      <div className="my-2">
        <hr />
        <h4 className="text-center pt-4">27% profit every 20 days?</h4>
        <p className="text-left p-[15px] mx-auto max-w-[650px]">
          This is what Nic Chahine averages with his option buys. Not selling covered calls or spreads... BUYING
          options. Most traders don&apos;t even have a winning percentage of 27% buying options. He has an 83% win rate.{' '}
          <strong>
            <a className="font-extrabold" href={href} rel="noreferrer" target="_blank">
              Here&apos;s how he does it.
            </a>
          </strong>
        </p>
        <hr />
      </div>
    );
  } else {
    const href =
      url ||
      (utmSource
        ? `https://events.benzinga.com/your-insider-report-1?utm_source=${utmSource}`
        : `https://events.benzinga.com/your-insider-report-1`);
    element = (
      <>
        <hr />
        <strong className="block text-center font-semibold pt-4">Secure Your Financial Future</strong>
        <p className="text-left p-[15px] mx-auto max-w-[630px]">
          Hidden gems are waiting to be found in this market! Don't miss the Benzinga Insider Report, typically
          $47/month, now ONLY $0.99! Uncover incredibly undervalued stocks before they soar! Limited time offer! Secure
          your financial success with this unbeatable discount!{' '}
          <strong>
            <a className="underline" href={href}>
              Grab your 0.99 offer TODAY!
            </a>
          </strong>
        </p>
        <p className="text-right px-0.5">
          <span className="text-[#808080]">
            <em>Advertorial</em>
          </span>
        </p>
        <hr />
      </>
    );
  }

  return (
    <Impression campaign_id={variant || ''} unit_type={`campaignify-${variant || 'default'}`}>
      <Container className="my-4 w-full">{element}</Container>
    </Impression>
  );
};

const Container = styled.div`
  .banner3 {
    font:
      600 16px/24px 'Manrope',
      sans-serif;
  }

  .banner3 * {
    box-sizing: border-box;
  }

  @media (max-width: 480px) {
    .benzinga-logo-white {
      width: 100%;
    }
  }
`;
